import request from '@/utils/request'

//工单列表（旧）
export function getTodoList(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/todo/list',
    method: 'post',
    data
  })
}
//工单列表（新）
export function getWorkOrderList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/work-order/page-list',
    method: 'post',
    data
  })
}
// 复诊提醒子工单列表
export function getSubTaskList(data) {
  return request({
    url: '/health-doctor-assistant/subTask/workOrder/subTask/query',
    method: 'get',
    params: data
  })
}
// 工单查询（step1）
export function getWorkOrderListAsyn(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/work-order/page-list/asyn',
    method: 'post',
    data
  })
}
// 工单查询（step2）
export function getWorkOrderListByTaskId(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/work-order-list/taskId',
    method: 'get',
    params: data
  })
}
// 子工单详情页面
export function getSubTaskDetail(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/workOrderDetailForFollowupReminder',
    method: 'get',
    params: data
  })
}

export function eventTypeList() {
  return request({
    url: '/health-doctor-assistant/workOrder/eventType/list',
    method: 'get'
  })
}
// 查询转交工单相关信息
export function queryTransferOrderInfo(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/queryTransferOrderInfo',
    method: 'get',
    params: data
  })
}

// 查询工单详情信息
export function workOrderDetail(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/workOrderDetail',
    method: 'get',
    params: data
  })
}
// 根据分配标签获取医助列表
export function getDoctorAssByAllocateTag(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/queryDoctorAssistantListByAllocateTag',
    method: 'get',
    params: data
  })
}

// 根据医生id获取医生科室排班信息
export function getScheduling(data) {
  return request({
    url: '/health-cure/cure/doctor/department/scheduling',
    method: 'get',
    params: data
  })
}

// 根据医生id获取医生科室排班信息
export function getNumberSource(data) {
  return request({
    url: '/health-cure/cure/doctor/number/source',
    method: 'get',
    params: data
  })
}

// 预约挂号
export function appointRegister(data) {
  return request({
    url: '/health-cure/cure/doctor/appoint/register',
    method: 'post',
    data
  })
}

// 预约挂号查询院区列表
export function getHospitalBranch(data) {
  return request({
    url: '/health-cure/cure/doctor/branch/hospital',
    method: 'get',
    params: data
  })
}

// 预约挂号查询科室列表
export function getDepartment(data) {
  return request({
    url: '/health-cure/cure/department/page',
    method: 'get',
    params: data
  })
}

// 预约挂号查询医生列表
export function getDoctor(data) {
  return request({
    url: '/health-doctor/user/page',
    method: 'post',
    data
  })
}

// 根据医生ID获取详细信息
export function getDoctorDetail(data) {
  return request({
    url: `/health-doctor/user/detail?doctorId=${data}`,
    method: 'post',
    data: {}
  })
}

// 根据患者id获取患者信息
export function getPatientDetail(data) {
  return request({
    url: `/health-user/user/patient/selectPatientById?id=${data}`,
    method: 'post',
    data: {}
  })
}

// 患者实名认证
export function patientRealverified(data) {
  return request({
    url: `/health-user/user/patient/realverified`,
    method: 'post',
    data
  })
}
